import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, TextField, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../theme';

const FullMemberDomains = ({ memberData }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState(memberData);

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);
        const filtered = memberData.filter((item) =>
            item.domain.toLowerCase().includes(query)
        );
        setFilteredData(filtered);
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'domain',
            headerName: 'Domain',
            width: 300,
            renderCell: (params) => (
                <a href={`http://${params.value}`} target="_blank" rel="noopener noreferrer">
                    {params.value}
                </a>
            )
        },
        {
            field: 'totalCount',
            headerName: 'Occurrences',
            width: 150,
        }
    ];

    const rows = filteredData.map((item, index) => ({
        id: index + 1,
        domain: item.domain,
        totalCount: item.totalCount,
    }));

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const formattedDate = yesterday.toLocaleDateString();

    return (
        <Box sx={{ height: '100%', width: '100%', padding: 2 }}>
            <Typography variant="h4" gutterBottom>
                Member Domains Seen on {formattedDate}
            </Typography>
            <TextField
                variant="outlined"
                fullWidth
                label="Search Domains"
                value={searchQuery}
                onChange={handleSearch}
                sx={{ marginBottom: 2 }}
            />
            <Box
                sx={{
                    height: 400,
                    width: '100%',
                    overflowY: 'auto', // Makes the DataGrid scrollable
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.blueAccent[600],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.grey[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.blueAccent[200]} !important`,
                    },
                }}
            >
                <DataGrid 
                    rows={rows} 
                    columns={columns} 
                    disableSelectionOnClick 
                    autoHeight 
                    rowsPerPageOptions={[]} 
                />
            </Box>
        </Box>
    );
};

export default FullMemberDomains;
